import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Typography,
  Box,
} from "@mui/material";
import {
  blackShade19,
  border25,
  borderTextBoxColor,
  greenShade01,
  greenShade17,
  greenStatusColor01,
  lightgreenColor04,
  lightYellowShade03,
  redColor09,
  redStatusColor01,
  whiteColor,
  yellowShade05,
} from "../../configs/styles/muiThemes";

function InventoryComparisonTable({ catalogData }) {
  return (
    <Box sx={styles.tableWrapper}>
      <TableContainer component={Box} sx={styles.tableContainer}>
        <Table sx={{ minWidth: 900 }}>
          <TableHead
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 20,
              background: whiteColor,
              // boxShadow: `0px 1px 1px rgba(0,0,0,0.1)`,
            }}
          >
            <TableRow>
              {catalogData?.header?.map((item, index) => (
                <TableCell
                  key={index}
                  sx={
                    index === 0
                      ? { ...styles.tablePreoductHeadCell, ...styles.colSticky }
                      : index === 1
                      ? {
                          ...styles.tableHeadHQCell,
                          ...styles.colSticky,
                          pt: "25px",
                        }
                      : styles.tableHeadCell
                  }
                >
                  {index === 1 && (
                    <Typography
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: "50%",
                        transform: "translateX(-50%)",
                        fontSize: "10px",
                        borderRadius: "4px",
                        color: whiteColor,
                        backgroundColor: greenShade01,
                        lineHeight: 1,
                        px: "10px",
                        py: "4px",
                      }}
                    >
                      Head Quaters
                    </Typography>
                  )}
                  {item?.name}
                </TableCell>
              ))}
            </TableRow>

            <TableRow sx={{ backgroundColor: lightYellowShade03 }}>
              <TableCell sx={styles.infoCellSticky1} />
              {catalogData?.productCount?.map((count, index) => (
                <TableCell
                  key={index}
                  sx={
                    index === 0
                      ? { ...styles?.infoCell, ...styles.infoCellSticky2 }
                      : styles?.infoCell
                  }
                >
                  {count} PRODUCTS
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {catalogData?.bodyData.map((row, index) => (
              <TableRow key={index}>
                <TableCell sx={styles.tableProductBodyCell}>
                  <Box display="flex" gap={2}>
                    <Box
                      component="img"
                      src={row?.headquarters?.productPhoto?.[0]?.docURL}
                      width="35px"
                      height="35px"
                      sx={{
                        objectFit: "cover",
                        borderRadius: "5px",
                        border: border25,
                      }}
                    />
                    {row?.productName}
                  </Box>
                </TableCell>
                <TableCell sx={styles.tableBodyHQCell}>
                  <Box display="flex" justifyContent="space-between" gap={2}>
                    <AvailabilityStatus
                      status={row?.headquarters?.availability?.[0]?.toUpperCase()}
                    />

                    <Typography
                      fontSize={12}
                      fontWeight={600}
                      color={blackShade19}
                      width="30%"
                    >
                      {row?.headquarters?.availableQuantity}
                    </Typography>
                  </Box>
                </TableCell>
                {row.branches.map((branch, i) => (
                  <TableCell key={i} sx={styles.tableBodyCell}>
                    <Box display="flex" justifyContent="space-between" gap={2}>
                      {branch?.availability?.length > 0 ? (
                        <AvailabilityStatus
                          status={branch?.availability?.[0]?.toUpperCase()}
                        />
                      ) : (
                        "-"
                      )}

                      {branch?.availability?.length > 0 && (
                        <Typography
                          fontSize={12}
                          fontWeight={600}
                          color={blackShade19}
                          width="30%"
                        >
                          {branch.availableQuantity}
                        </Typography>
                      )}
                    </Box>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default InventoryComparisonTable;

const AvailabilityStatus = ({ status }) => {
  return (
    <Box
      sx={{
        // flex: 0.7,
        fontWeight: 500,
        fontSize: "12px",
        color: status == "YES" ? greenStatusColor01 : redStatusColor01,
        justifyContent: "center",
        backgroundColor: status == "YES" ? lightgreenColor04 : redColor09,
        // padding: "2px 20px",
        width: "80px",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
      }}
    >
      {status == "YES" ? "Selling" : "Not Selling"}
    </Box>
  );
};

const styles = {
  tableWrapper: {
    width: "calc(100vw - 280px)",
    // borderRadius: "8px",
    // border: `1px solid ${borderTextBoxColor}`,
  },
  tableContainer: {
    backgroundColor: whiteColor,
    border: border25,
    borderRadius: "10px",
    overflowX: "scroll", // Enables horizontal scrolling
    maxWidth: "100%",
    maxHeight: "65vh",
    "&::-webkit-scrollbar": {
      width: "4px",
      height: "4px",
      borderRadius: "50px !important",
    },
    "&::-webkit-scrollbar-thumb": {
      // background: '#d0d3da',
      background: "rgba(0,0,0,0.1)",
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(0,0,0,0.05)",
    },
  },

  tablePreoductHeadCell: {
    width: "360px",
    fontSize: 12.5,
    fontWeight: 600,
    color: blackShade19,
    background: whiteColor,
  },
  tableHeadHQCell: {
    width: "260px",
    fontSize: 12.5,
    fontWeight: 600,
    color: blackShade19,
    background: greenShade17,
    position: "relative",
  },
  tableHeadCell: {
    width: "260px",
    fontSize: 12.5,
    fontWeight: 600,
    color: blackShade19,
  },
  colSticky: {
    ":first-child": {
      position: "sticky",
      left: "0px",
    },
    ":nth-child(2)": {
      position: "sticky",
      left: "360px",
      boxShadow: `-1px 0 0 0 ${borderTextBoxColor} inset, 0px 1px 0px 0px ${borderTextBoxColor}`,
    },
  },
  tableProductBodyCell: {
    minWidth: "360px",
    fontSize: 12.5,
    fontWeight: 600,
    color: blackShade19,
    position: "sticky",
    left: "0",
    zIndex: 12,
    background: whiteColor,
  },
  tableBodyHQCell: {
    minWidth: "260px",
    position: "sticky",
    left: "360px",
    zIndex: 12,
    background: greenShade17,
    boxShadow: `-1px 0 0 0 ${borderTextBoxColor} inset`,
  },
  tableBodyCell: {
    minWidth: "260px",
  },

  chip: {
    background: lightgreenColor04,
    color: greenStatusColor01,
    fontSize: 12,
    fontWeight: 500,
    p: "2px 4px",
    borderRadius: "4px",
    width: "48px",
    display: "flex",
    justifyContent: "center",
  },

  infoCell: {
    py: 0,
    color: yellowShade05,
    fontWeight: 500,
    fontSize: "10px",
    maxHeight: "15px",
  },

  infoCellSticky1: {
    minWidth: "360px",
    position: "sticky",
    left: "0",
    zIndex: 12,
    background: lightYellowShade03,
  },
  infoCellSticky2: {
    position: "sticky",
    left: "360px",
    zIndex: 12,
    background: lightYellowShade03,
    boxShadow: `-1px 0 0 0 ${borderTextBoxColor} inset`,
  },
};
